module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Breadcrumbs":{"separator":"&sol;"}},"de":{"Breadcrumbs":{"separator":"&sol;"}},"sk":{"Breadcrumbs":{"separator":"&sol;"}}}')
  delete Component.options._Ctor
}
